import { DeleteIcon, SearchIcon } from "@chakra-ui/icons";
import {
  Badge,
  Button,
  Flex,
  IconButton,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Td,
  Text,
  Tr,
  useDisclosure,
  Tooltip,
} from "@chakra-ui/react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { FaYoutube } from "react-icons/fa";

const VideoItem = ({ video, onDelete }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isLoading, setIsLoading] = useState(false);
  const bucket = process.env.REACT_APP_S3_BUCKET;
  const region = process.env.REACT_APP_S3_REGION;
  const folder = "videos_images";

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size="md">
        <ModalOverlay />
        <ModalContent borderRadius="1rem">
          <ModalHeader fontSize="1rem" fontWeight={700} borderBottom="1px solid" borderColor="gray.100" pb={3}>
            {video.name}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody py={4}>
            <Text fontSize="0.85rem" color="gray.500" mb={3}>Por {video.authorName}</Text>
            <Image
              src={`https://${bucket}.s3.${region}.amazonaws.com/${folder}/${video?.image}`}
              objectFit="cover"
              borderRadius="0.5rem"
              mb={3}
            />
            <Flex gap={1} wrap="wrap" mb={2}>
              {video?.tags?.map((el) => (
                <Badge key={el} colorScheme="green" px={2} py={0.5} borderRadius={4} fontSize="0.72rem">
                  {el}
                </Badge>
              ))}
            </Flex>
            <Link to={video.url} target="_blank" style={{ color: "#22a45a", fontSize: "0.85rem" }}>
              Abrir vídeo no YouTube ↗
            </Link>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="green" variant="outline" size="sm" onClick={onClose}>Fechar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Tr>
        <Td maxW="200px" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap" title={video.name} fontSize="0.82rem">{video.name}</Td>
        <Td maxW="140px" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap" fontSize="0.82rem">{video.eventName}</Td>
        <Td maxW="130px" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap" fontSize="0.82rem">{video.authorName}</Td>
        <Td>
          <Flex gap={2}>
            <Link to={video.url} target="_blank">
              <Tooltip label="Abrir no YouTube">
                <IconButton colorScheme="red" variant="ghost" aria-label="YouTube" size="xs" icon={<FaYoutube />} />
              </Tooltip>
            </Link>
            <Tooltip label="Detalhes do vídeo">
              <IconButton colorScheme="green" variant="ghost" aria-label="Detalhes" size="xs" onClick={onOpen} icon={<SearchIcon />} />
            </Tooltip>
            <Tooltip label="Excluir vídeo">
              <IconButton
                colorScheme="red"
                variant="ghost"
                aria-label="Deletar"
                size="xs"
                isLoading={isLoading}
                onClick={() => { setIsLoading(true); onDelete(video.videoId); }}
                icon={<DeleteIcon />}
              />
            </Tooltip>
          </Flex>
        </Td>
      </Tr>
    </>
  );
};
export default VideoItem;
